import { type ReactElement, useEffect, useState } from 'react';

import { type FragmentProperties } from './Fragment';
import { getFragmentName } from './getFragmentName';
import { createClient } from './sentry';
import { SentryErrorBoundary } from './SentryErrorBoundary';

// eslint-disable-next-line react/function-component-definition
function SentryWrapper<PropertiesType>({
    children,
    sentry,
}: {
    readonly children: ReactElement;
    readonly sentry: FragmentProperties<PropertiesType>['sentry'];
}): JSX.Element {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    if (isClient && window.Sentry && sentry?.enabled) {
        const { dsn, environment, release } = sentry;
        const sentryClient = createClient({
            fragmentId: getFragmentName(),
            dsn,
            environment,
            release,
        });

        return (
            <SentryErrorBoundary dsn={dsn} sentryClient={sentryClient}>
                {children}
            </SentryErrorBoundary>
        );
    }

    return children;
}

export { SentryWrapper };
